import React, { useContext, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';

import { acknowledgeOrder } from './order-api';

export function OrderAcknowledgeDialog({
  orderId,
  handleClose,
}: {
  orderId?: string;
  handleClose: () => void;
}) {
  const { showNotification } = useContext(NotificationCtx);
  const [signed, setSigned] = useState(false);

  const handlePrint = async () => {
    // TODO Print
    setSigned(true);
  };

  const handleSign = async () => {
    const { ok, data } = await acknowledgeOrder(orderId!);

    if (ok) {
      showNotification(
        'Žádost uložena ako podepsáná',
        NotificationVariant.SUCCESS
      );
      handleClose();
    } else {
      showNotification(
        `Při podepsání žádosti došlo k chybě
				${data?.message}`,
        NotificationVariant.ERROR
      );
    }
  };

  return (
    <Dialog open={!!orderId} onClose={handleClose} scroll="paper">
      <DialogTitle>Potvrzení objednávky</DialogTitle>
      <DialogContent dividers={true}>
        <DialogContentText>
          <p>Vytisknete potvrzení které badatel podepíše.</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSign} color="primary" disabled={!signed}>
          Podepsáno
        </Button>
        <Button onClick={handlePrint}>Vytisknout</Button>
        <Button onClick={handleClose}>Zavřít</Button>
      </DialogActions>
    </Dialog>
  );
}
